/*
 * File: 会议取消提示
 * File Created: 2021-05-14 4:19:03 pm
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-05-18 2:42:14 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div class="meeting-canceled-tips">
    <img
      src="../../assets/images/icons/warning.png"
      alt=""
      width="80"
      height="80"
    >
    <span class="meeting-status">{{ $t('meeting.hasCanceled') }}</span>
    <span class="meeting-tips">{{ $t('meeting.cancelMeetingInfo') }}</span>
  </div>
</template>

<script>
export default {
  name: 'meeting-canceled-tips',
}
</script>

<style lang='less' scoped>
  .meeting-canceled-tips {
    display: flex;
    flex-direction: column;
    align-items: center;
    & > img {
      margin-top: 47px;
    }
    .meeting-status {
      font-size: 18px;
      line-height: 26px;
      color: #F1B634;
      margin: 12px 0;
    }
    .meeting-tips {
      font-size: 14px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.45);
    }
  }
</style>
